import axios from "../login/api/axios"

const ITEMS_URL = '/items/items';
const ITEM_CREATE_URL = '/items/itemCreate';
const ITEM_UPDATE_URL = '/items/itemUpdate';
const TRANSLATION_UPDATE_URL = '/items/translationUpdate';


export interface itemsFromDatabase  {
    success: [
      {
        id: number;
        nodeid: string;
        label: string;
        type: number;
        parent: number;
        typeIcon: number;
        busCmoduleTypeonsumption: number;
        webCat: number;
        createdAt: string;
        updatedAt: string;
      }
    ]
  }

  
export async function GetOutputsFromDatabase(type:string, lang?: string) {

  const accessToken = sessionStorage.getItem('accessToken')
  const storedLanguage = (lang || sessionStorage.getItem("language") || "NL").replace(/"/g, "").toUpperCase();
  const language = ["NL", "FR", "EN"].includes(storedLanguage)
    ? storedLanguage
    : "NL";

  const ItemsFromDatabase = new Promise<itemsFromDatabase>((resolve, reject) => {
    axios.get(
      ITEMS_URL,
      {
        headers: { 
          'Authorization' : 'Bearer ' + accessToken,
          "Content-Type": "application/json",
        },
        withCredentials: true,
        params:
          type === "ingangen" || type === "uitgangen"
            ? { type: type, lang: language }
            : { type: type }
      }
    )

    .then(res => {
      if (res) {
        resolve (res.data)
      } else {
        reject ("DB No items found")
      }
    })
    .catch(error => {
      console.log ("Error: DB No items found: " + error)
    })
  }); 

    const t = await ItemsFromDatabase
    //console.log(t)
    return t
} 

export function createItem(
  type: "ingangen" | "uitgangen",
  nodeid: string,
  parent: string,
  typeIcon: string,
  moduleType: string,
  webCat: number,
  offCat: number,
  labels: Record<string, string>
) {
  const accessToken = sessionStorage.getItem('accessToken');

  return axios.post(
    ITEM_CREATE_URL,
    JSON.stringify({ type, nodeid, parent, typeIcon, moduleType, webCat, offCat, labels }),
    {
      headers: {
        'Authorization': 'Bearer ' + accessToken,
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );
}

export function updateItem(type: "ingangen" | "uitgangen", id: number, nodeid: string, typeIcon: string, moduleType: string, webCat: number, offCat: number) {
  const accessToken = sessionStorage.getItem('accessToken');

  return axios.post(
    ITEM_UPDATE_URL,
    JSON.stringify({ type, id, nodeid, typeIcon, moduleType, webCat, offCat }),
    {
      headers: {
        'Authorization': 'Bearer ' + accessToken,
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );
}

export function updateTranslation(type: "ingangen" | "uitgangen", id: number, language: "NL" | "FR" | "EN", label: string) {
  const accessToken = sessionStorage.getItem('accessToken');

  return axios.post(
    TRANSLATION_UPDATE_URL,
    JSON.stringify({ type, id, language, label }),
    {
      headers: {
        'Authorization': 'Bearer ' + accessToken,
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );
}
